var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"media_release_title",attrs:{"src":_vm.title}}),_c('span',{staticClass:"media_release_span"},[_vm._v(_vm._s(_vm.remark))])])
}
var staticRenderFns = []

export { render, staticRenderFns }